import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/AdminNavbar.css';

const AdminNavbar = ({ newOrder, setNewOrder, orders }) => {
  const navigate = useNavigate();
  const [showNotifications, setShowNotifications] = useState(false);

  const handleNotificationClick = () => {
    setNewOrder(false); // Clear notification dot
    setShowNotifications(!showNotifications); // Toggle popup
  };

  return (
    <nav className="admin-navbar">
      {/* Left Title */}
      <h1>GITAAMI</h1>

      {/* Right Side */}
      <div className="nav-right">
        {/* Search */}
        <div className="nav-search">
          <input type="text" placeholder="Search..." />
          <i className="fas fa-search"></i>
        </div>

     
        <button className="icon-btn" onClick={handleNotificationClick}>
  <i className="fas fa-bell"></i> 
  {newOrder && <span className="notification-dot"></span>}
</button>


        {/* Notification Popup */}
        {showNotifications && (
          <div className="notification-popup">
            <h3>New Orders</h3>
            {orders.length === 0 ? (
              <p>No orders available.</p>
            ) : (
              <ul>
                {orders.slice(0, 5).map(order => (
                  <li key={order.id} className="order-item">
                    <p><strong>Order ID:</strong> {order.id}</p>
                    <p><strong>Name:</strong> {order.shipping?.name}</p>
                    <p><strong>Total:</strong> ₹{order.total}</p>
                    <p><strong>Status:</strong> {order.status}</p>
                    <p><strong>Payment:</strong> {order.paymentMethod}</p>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}

        {/* Avatar */}
        <img className="avatar" src="/Gitammi_Logo.JPG" alt="User" />

        {/* Logout */}
        <button className='logout-btn' onClick={() => {
          localStorage.removeItem('isAdminLoggedIn');
          navigate('/admin/login');
        }}>Logout</button>
      </div>
    </nav>
  );
};

export default AdminNavbar;
